import { useEffect, useMemo } from 'react';
import { Button } from 'react-bootstrap';
// import { useForm } from 'react-hook-form';
import { AiOutlineDelete } from 'react-icons/ai';
import { BsListUl } from 'react-icons/bs';
import { FaPlus, FaRegEdit } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactTable from '../../../../Components/ReactTable/ReactTable';
import {
  clearTable,
  // createTableData,
  deleteTableData,
  // editTableData,
  handleEmployeeLevelListChange
} from '../../../../Redux/slices/table';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
// import SingleFormInput from '../components/SingleFormInput';
import { toast } from 'react-toastify';
import { getSingleEmployeeLevel } from '../../../../Redux/slices/employeelevel';
// import SubmitBtn from '../../../../Components/Buttons/SubmitBtn';
// import { FormGroup } from '../../../../Components/FormGroup/FormGroup';

function EmployeeLevel() {
  const navigate = useNavigate();

  // const { edit: isEdit } = useParams();
  // const [employee_type, setEmployeeType] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const results = useSelector((state) => state.table.results);
  // const ShowForm = (check) => {
  //   if (isEdit) {
  //     setEmployeeType(false);

  //     navigate('/admin/settings/employee_type/');
  //   } else {
  //     setValue('title', '');
  //     check = !check;
  //     check ? setEmployeeType(true) : setEmployeeType(false);
  //   }
  // };
  // const {
  //   register,
  //   handleSubmit,
  //   setValue,
  //   // watch,
  //   formState: { errors }
  // } = useForm({ mode: 'onBlur', defaultValues: {} });

  // const onSubmit = async (data) => {
  //   setIsLoading(true);
  //   try {
  //     if (employee_type && !isEdit) {
  //       let response = await fetchWrapper.post('/employee-type/', data);
  //       dispatch(createTableData(response.data));
  //       toast.success(<FormattedMessage id="employee_type_created" />);

  //       setIsLoading(false);
  //       setEmployeeType(false);
  //       navigate('/admin/settings/employee_type/');
  //     }
  //     if (isEdit) {
  //       let response = await fetchWrapper.patch(`/employee-type/${id}/`, data);
  //       dispatch(editTableData(response.data));
  //       toast.success(<FormattedMessage id="employee_type_updated" />);

  //       setIsLoading(false);
  //       setEmployeeType(false);

  //       navigate('/admin/settings/employee_type/');
  //     }
  //   } catch (error) {
  //     ErrorMessageHandler(error);
  //   }
  // };

  const columns = useMemo(
    () => [
      { Header: <FormattedMessage id="sn" />, accessor: 'serial_number' },
      {
        Header: <FormattedMessage id="category" />,
        accessor: 'title'
      },
      {
        Header: <FormattedMessage id="sub_category" />,
        accessor: 'childrens'
      },

      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions'
      }
    ],
    []
  );

  const handleDelete = async (id) => {
    try {
      await fetchWrapper.delete(`/employee-type/${id}/`);
      toast.success(<FormattedMessage id="employee_type_deleted" />);
      dispatch(deleteTableData(id));
      navigate('/admin/settings/employee_type_level/');
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const handleEdit = (employeeLevel) => {
    dispatch(getSingleEmployeeLevel(employeeLevel));
    navigate(`/admin/settings/employee_type_level/${employeeLevel.id}/edit`);
  };

  const data = useMemo(() => {
    if (results) {
      let count = 1;
      return results.map((result) => {
        let action = (
          <div className="d-flex">
            <div className="mx-2">
              <Button variant="outline-success " onClick={() => handleEdit(result)}>
                <FaRegEdit />
              </Button>
            </div>
            <div className='"mx-2'>
              <Button variant="outline-danger " onClick={() => handleDelete(result.id)}>
                <AiOutlineDelete />
              </Button>
              <i className={result.icon} />
            </div>
          </div>
        );
        return {
          serial_number: count++,
          title: result.title,
          childrens: result?.childrens?.map((child) => child.title).join(', '),
          actions: action
        };
      });
    }
  }, [results]);

  const handleEmployeeTypeFetch = ({ index, pageSize }) => {
    dispatch(handleEmployeeLevelListChange({ index: index, pageSize: pageSize }));
  };
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  return (
    <div className="card content-section p-3">
      <div className="d-flex justify-content-between align-items-end">
        <h4 className="d-inline-block text-primary">
          <BsListUl size={35} />
          &nbsp;
          <FormattedMessage id="employee_type_level" />
        </h4>
        <div className="d-flex justify-content-between align-items-end">
          <Button
            variant="primary"
            onClick={() => navigate('/admin/settings/employee_type_level/add')}
            // disabled={employee_type}
          >
            <FaPlus size={18} />
            <FormattedMessage id="add_new" />
          </Button>
        </div>
      </div>
      <hr />
      {/* <div>
        {(isEdit || employee_type) && (
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="ps-3">
                <SingleFormInput
                  inputType="text"
                  register={register}
                  title="employee_type"
                  id={id}
                  type="employee-type"
                  errors={errors}
                  isEdit={isEdit}
                  setValue={setValue}
                />{' '}
                {/* <div className="col-md-6">
                  <FormGroup
                    id="first_parent"
                    register={register}
                    onChange={(e) => {
                      setValue('first_parent', e.value);
                    }}
                    type="select"
                    label="Category"
                    options={results.map((result) => ({ value: result.id, label: result.title }))}
                  />
                  {watch('first_parent') && (
                    <FormGroup
                      id="second_parent"
                      register={register}
                      onChange={(e) => {
                        setValue('second_parent', e.value);
                      }}
                      type="select"
                      label="Sub Category"
                      options={results
                        .find((result) => result.id === watch('first_parent'))
                        ?.childrens?.map((child) => ({ value: child.id, label: child.title }))}
                    />
                  )}
                </div> */}
      {/* <div className="d-flex mt-3">
                  <Button
                    variant="danger"
                    className="me-2"
                    onClick={() => {
                      ShowForm(employee_type);
                    }}>
                    <FormattedMessage id="button.cancel" />
                  </Button>
                  <SubmitBtn
                    isLoading={isLoading}
                    buttonText={<FormattedMessage id="button.save" />}
                    icon="none"
                  />
                </div>
              </div>
            </form> */}
      {/* </> */}
      {/* )} */}
      {/* // </div>  */}

      <div className="">
        <ReactTable data={data} columns={columns} dataFetcher={handleEmployeeTypeFetch} />
      </div>
    </div>
  );
}

export default EmployeeLevel;
